import React from 'react';

import { HeroPlannerScheduleDebugOutcome } from '~/queries/customerCommunication/requestGetTodaysEscapesScheduleDebug';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import ErrorIcon from '@mui/icons-material/Error';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import { Chip, CircularProgress } from '@mui/material';

import { HeroPlannerDebugRowStatus } from '../../utils/heroPlannerDebugUtils';

const HTTP_STATUS_LABELS: Record<number, string> = {
  0: 'Network error',
  400: 'Bad request',
  401: 'Unauthorised',
  403: 'Forbidden',
  404: 'Not found',
  409: 'Conflict',
  500: 'Server error',
  502: 'Bad gateway',
  503: 'Unavailable',
  504: 'Timeout',
};

interface Props {
  status: HeroPlannerDebugRowStatus;
  outcome?: HeroPlannerScheduleDebugOutcome;
}

function HeroPlannerDebugStatusChip({ status, outcome }: Props) {
  if (status === 'skipped') {
    return <Chip size="small" variant="outlined" icon={<DoNotDisturbOnIcon />} label="Not sent" />;
  }

  if (status === 'heroOnly') {
    return <Chip size="small" color="info" icon={<HourglassTopIcon />} label="Hero row only" />;
  }

  if (status === 'regenerating') {
    return <Chip size="small" color="warning" icon={<SyncProblemIcon />} label="Regenerating" />;
  }

  if (status === 'loading' || !outcome) {
    return <Chip size="small" variant="outlined" label="Checking" icon={<CircularProgress size={12} />} />;
  }

  if (outcome.ok) {
    return <Chip size="small" color="success" icon={<CheckCircleIcon />} label={outcome.status} />;
  }

  const label = HTTP_STATUS_LABELS[outcome.status];

  return (
    <Chip
      size="small"
      color="error"
      icon={<ErrorIcon />}
      label={outcome.status === 0 ? label : [outcome.status, label].filter(Boolean).join(' · ')}
    />
  );
}

export default HeroPlannerDebugStatusChip;
